module.exports = __webpack_public_path__ + "img/invoice_logo.805bb853.svg";